import { render, staticRenderFns } from "./BillingPayments.vue?vue&type=template&id=571ee450&scoped=true&"
import script from "./BillingPayments.vue?vue&type=script&lang=js&"
export * from "./BillingPayments.vue?vue&type=script&lang=js&"
import style0 from "./BillingPayments.vue?vue&type=style&index=0&id=571ee450&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "571ee450",
  null
  
)

/* custom blocks */
import block0 from "./BillingPayments.vue?vue&type=custom&index=0&blockType=i18n&lang=yml&locale=ru"
if (typeof block0 === 'function') block0(component)
import block1 from "./BillingPayments.vue?vue&type=custom&index=1&blockType=i18n&lang=yml&locale=en"
if (typeof block1 === 'function') block1(component)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VPagination } from 'vuetify/lib/components/VPagination';
installComponents(component, {VPagination})
